export default {
    black: {
        100: 'rgba(0, 0, 0, 0.07)',
        200: 'rgba(0, 0, 0, 0.2)',
        300: 'rgba(0, 0, 0, 0.33)',
        400: 'rgba(0, 0, 0, 0.4)',
        500: 'rgba(0, 0, 0, 0.5)',
        600: 'rgba(0, 0, 0, 0.6)',
        700: 'rgba(0, 0, 0, 0.7)',
        800: 'rgba(0, 0, 0, 0.8)',
        900: 'rgba(0, 0, 0, 0.9)'
    },
    grey: {
        100: 'rgba(72, 72, 72, 0.07)',
        200: 'rgba(72, 72, 72, 0.2)',
        300: 'rgba(72, 72, 72, 0.33)',
        400: 'rgba(72, 72, 72, 0.4)',
        500: 'rgba(72, 72, 72, 0.5)',
        600: 'rgba(72, 72, 72, 0.6)',
        700: 'rgba(72, 72, 72, 0.7)',
        800: 'rgba(72, 72, 72, 0.8)',
        900: 'rgba(72, 72, 72, 0.9)'
    }
};



// WEBPACK FOOTER //
// ./app/themes/default-theme/shadows.js